/**
 * [wxRegister 微信Api初始化]
 * 依赖weixin-js-sdk和vue-jsonp
 * 执行npm install weixin-js-sdk --save
 * 执行npm install vue-jsonp --save
 * 页面import
 * 调用wxInit
 */

 import wx from 'weixin-js-sdk'
 import { jsonp } from 'vue-jsonp'
 
 const wxApi = {
     /**
      * [wxRegister 微信Api初始化]
      * @param  {Function} callback [ready回调函数]
      */
     wxRegister(data,option) { //data是微信配置信息，option是分享的配置内容
         //console.log(data);
         //console.log(option);
         wx.config({
             debug: false, // 开启调试模式
             appId: data.appId, // 必填，公众号的唯一标识
             timestamp: data.timestamp.toString(), // 必填，生成签名的时间戳
             nonceStr: data.nonceStr, // 必填，生成签名的随机串
             signature: data.signature, // 必填，签名，见附录1
             jsApiList: data.jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
         })
         wx.ready(function(){
             wx.updateTimelineShareData({
                 title: option.title, // 分享标题
                 link: option.link, // 分享链接
                 imgUrl: option.imgUrl, // 分享图标
                 desc: option.desc, // 分享描述
                 success() {
                     // 用户成功分享后执行的回调函数
                     option.success && option.success();
                 },
                 cancel() {
                     // 用户取消分享后执行的回调函数
                     option.error && option.error();
                 }
             });
             wx.updateAppMessageShareData({
                 title: option.title, // 分享标题
                 desc: option.desc, // 分享描述
                 link: option.link, // 分享链接
                 imgUrl: option.imgUrl, // 分享图标
                 success() {
                     // 用户成功分享后执行的回调函数
                     option.success && option.success();
                 },
                 cancel() {
                     // 用户取消分享后执行的回调函数
                     option.error && option.error();
                 }
             });
             wx.error(function(v) {
                 console.log(v)
             });            
         })
     },
 
     wxInit(option){
 
         var ua = navigator.userAgent;
         var isWX = ua.match(/MicroMessenger\/([\d\.]+)/);
 
         if(!isWX)return;
 
         jsonp('https://weixinmp.m3guo.com/wechat/get_signature/',{
             url : option.link,
             callbackQuery: 'callback',
             callbackName: 'wxGetTickCallback',
         })
         .then(res => {
            if(res.code == 0){
                this.wxRegister(res.data,option);
            }
         }).catch((err)=>{
              console.log(err);
         });
     },
 }
 export default wxApi